<template>
  <component
    :is="currentView"
    :partId="partId"
    :newPart="newPart"
    :class="{ 'is-active': activePartId === partId }"
    @click.native.stop="setActivePartId(partId)"
    @save="$emit('save', $event)"
    @cancel="$emit('cancel')"
    @add="$emit('add', $event)"
  />
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import FormTemplateSection from './FormTemplateSection'
import FormTemplateQuestion from './FormTemplateQuestion'
import FormTemplateParagraph from './FormTemplateParagraph'
import FormTemplateEsignature from './FormTemplateEsignature'
import FormTemplatePageBreak from './FormTemplatePageBreak'

export default {
  name: 'FormTemplatePart',
  props: [ 'partId', 'newPart' ],
  components: {
    FormTemplateSection,
    FormTemplateQuestion,
    FormTemplateParagraph,
    FormTemplateEsignature,
    FormTemplatePageBreak
  },
  computed: {
    ...mapState('formtemplate', ['activePartId']),
    ...mapGetters('formtemplate', [
      'partById'
    ]),
    part: function () {
      if (this.partId && typeof this.partId === 'object') {
        return this.partId
      }
      return this.partById(this.partId) || this.newPart
    },
    currentView: function () {
      if (!this.part) return null
      switch (this.part.part_type) {
        case 's': return 'FormTemplateSection'
        case 'q': return 'FormTemplateQuestion'
        case 'p': return 'FormTemplateParagraph'
        case 'e': return 'FormTemplateEsignature'
        case 'b': return 'FormTemplatePageBreak'
        default: return null
      }
    }
  },
  methods: {
    ...mapMutations('formtemplate', ['setActivePartId'])
  }
}
</script>

<style scoped>
.draggable-item.is-active {
  border-left: 4px solid #2196f3;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #fff !important;
  transform: translateX(2px);
}
</style>
